export default __webpack_public_path__ + "static/media/6.b7b2321a.png";